export default __webpack_public_path__ + "static/media/Yellow_man.d961abb3.png";